// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';  // 根据pc或移动显示隐藏div
import axios from 'axios';
import ElementUI, { Message, MessageBox } from 'element-ui';
import '@/assets/styles/global.scss' // css模块化，全局引入

import YuuPagelist from '@/components/Pagelist' // 全局注册分页组件
import YuuBread from '@/components/bread'
Vue.use(ElementUI)
Vue.component('yuu-pagelist',YuuPagelist)
Vue.component('yuu-bread', YuuBread)
Vue.prototype.$axios = axios
Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js